import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";

function CustomTooltip({
  id = "uniqueId",
  content = "",
  linesVisible = 2,
  sx = {},
  children,
  disableTooltip = false,
}) {
  const [showTooltip, setShowTooltip] = useState(false);
  // const shouldShowTooltip = showTooltip && !disableTooltip;

  const [lines, setLines] = useState(1);
  const text = children || content;

  useEffect(() => {
    let element = document.getElementById(id);
    let fontSize = parseFloat(getComputedStyle(element).fontSize);
    let numberOfLines = Math.floor(element.offsetHeight / fontSize);
    setLines(numberOfLines);
  }, [id]);

  const formatText = (text) => {
    const str = String(text);
    if (!str.includes(" ")) {
      return str.match(/.{1,20}/g)?.join("\u200B");
    }
    return text;
  };

  return lines > linesVisible ? (
    <Tooltip
      title={content}
      arrow
      disableHoverListener={disableTooltip}
      disableFocusListener={disableTooltip}
      disableTouchListener={disableTooltip}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#fff",
            color: "#3A3A3A",
            fontSize: "1.2rem",
            padding: "8px",
            border: "1px solid lightgray",
            boxShadow: "0px 4px 15px rgba(0,0,0,0.25)",
            "& .MuiTooltip-arrow": {
              color: "#fff",
              width: "2rem",
              height: "1rem",
            },
            "& .MuiTooltip-arrow::before": {
              border: "1px solid lightgray",
            },
            [".MuiTooltip-popper[data-popper-placement*='bottom'] &"]: {
              marginTop: "1rem !important",
              ".MuiTooltip-arrow": {
                marginTop: "-1rem !important",
              },
            },
            [".MuiTooltip-popper[data-popper-placement*='top'] &"]: {
              marginBottom: "1rem !important",
              ".MuiTooltip-arrow": {
                marginBottom: "-1rem !important",
              },
            },
            ...sx,
          },
        },
      }}
    >
      <span
        id={id}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "break-all",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          "-webkit-line-clamp": linesVisible?.toString(),
          "-webkit-box-orient": "vertical",
        }}
      >
        {children ? children : formatText(text)}
      </span>
    </Tooltip>
  ) : (
    <span id={id}>{children ? children : formatText(text)}</span>
  );
}

export default CustomTooltip;
